class Footer extends window.HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      const toggle = event.target.closest(".mudify-footer__menu-toggle");
      if (!toggle || !this.contains(toggle) || window.innerWidth > 767) return;
      const menu = toggle.closest(".mudify-footer__menu");
      const menuList = menu.querySelector(".mudify-footer__menu-list");
      const icon = toggle.querySelector("svg");
      const isOpen = toggle.getAttribute("aria-expanded") !== "true";
      toggle.setAttribute("aria-expanded", String(isOpen));
      menuList == null ? void 0 : menuList.classList.toggle("hidden", !isOpen);
      menuList == null ? void 0 : menuList.classList.toggle("grid", isOpen);
      icon == null ? void 0 : icon.classList.toggle("rotate-180", isOpen);
    });
  }
}
if (!window.customElements.get("footer-element")) window.customElements.define("footer-element", Footer);
